import { createIsomorphicFn } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'
import { isLocale, parseLocale, type Locale } from 'shared/locales'

// Resolved from the REQUEST so SSR renders the locale the client will hydrate with; otherwise an English browser
// hydrates against the es-ES default's HTML (#418). null on the client, where the store derives it at module load.
export const resolveServerLocale = createIsomorphicFn()
  .server((): Locale | null => {
    const req = getRequest()
    const url = new URL(req.url)

    const langParam = url.searchParams.get('lang')
    if (isLocale(langParam)) return langParam

    const cookieHeader = req.headers.get('cookie') ?? ''
    const cookieMatch = /(?:^|;\s*)language=([^;]+)/.exec(cookieHeader)
    const cookieLang = cookieMatch?.[1] ? decodeURIComponent(cookieMatch[1]) : undefined
    if (isLocale(cookieLang)) return cookieLang

    return parseLocale({ 'accept-language': req.headers.get('accept-language') ?? undefined })
  })
  .client((): Locale | null => null)
